import { render, staticRenderFns } from "./VersionModal.vue?vue&type=template&id=3bbef870&scoped=true&"
import script from "./VersionModal.vue?vue&type=script&lang=js&"
export * from "./VersionModal.vue?vue&type=script&lang=js&"
import style0 from "./VersionModal.vue?vue&type=style&index=0&id=3bbef870&prod&lang=css&"
import style1 from "./VersionModal.vue?vue&type=style&index=1&id=3bbef870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbef870",
  null
  
)

export default component.exports